<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_vehicleNature"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>

        <el-button type="primary" @click="funcBatchConfirm">
          批量确认
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      show-footer
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="driverName" title="实际承运人姓名" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="driverPhone" title="联系方式" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverAuthStatus"
          title="实际承运人状态"
          :formatter="formatterAuthStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.driverAuthStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="licenseNumber" title="绑定车辆" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleAuthStatus"
          title="车辆状态"
          :formatter="formatterAuthStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleAuthStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMaster"
          title="是否主驾"
          :formatter="formatterIsMaster"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMaster"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isMasterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleNature"
          title="车辆性质"
          :formatter="formatterVehicleNature"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleNature"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in vehicleTypeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 是否上传 -->
      <vxe-table-column>
        <vxe-table-column
          field="agreementStatus"
          title="是否上传"
          :formatter="formatterAgreementStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.agreementStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in agreementStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看协议"
            placement="top"
          >
            <vxe-button
              type="text"
              style="color: #1890ff;cursor: pointer;"
              @click="showCollectionAgreementModel(scope.row)"
            >
              查看协议
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="collectionAgreementFlag"
      title="查看协议"
      width="800"
      height="500"
    >
      <el-form v-if="collectionAgreementFlag" class="vehicle-agreement-form">
        <div class="form-section">
          <h3>车辆性质</h3>
          <el-radio-group v-model="vehicleNature">
            <el-radio
              v-for="item in vehicleTypeOptions"
              :key="item.code"
              :label="item.code"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="form-section">
          <h3>上传协议</h3>
          <multipleUpload
            :required="false"
            :max-count="10"
            :disabled="false"
            :img-list.sync="imgList"
          />
        </div>
      </el-form>
      <div class="modal-footer">
        <el-button type="primary" @click="uploadVehicleAgreementApi"
          >确定</el-button
        >
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="collectionAgreementLogListFlag"
      title="代收协议记录"
      width="800"
      height="800"
    >
      <collectionAgreementLogList
        ref="collectionAgreementLogListRef"
        @hideModel="hideCollectionAgreementLogListModel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import multipleUpload from "@/components/ImgUpload/multipleUpload.vue";
import {
  VehicleType,
  uploadVehicleAgreement,
  pendingConfirmList,
  batchConfirm
} from "@/api/orderform";
import collectionAgreementLogList from "@/views/basicInfo/driver/driverManage/components/vehicleTeam/collectionAgreementLogList.vue";

export default {
  name: "VehicleNature",
  components: {
    collectionAgreementLogList,
    multipleUpload
  },
  data() {
    return {
      rowObj: {},
      imgList: [],
      vehicleNature: "",
      vehicleTypeOptions: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportJoinedTeamList",
        name: "车辆性质审核"
      },
      loading: false,
      collectionAgreementLogListFlag: false,
      collectionAgreementFlag: false,
      tableData: [],
      authStatusOptions: [
        { label: "未审核", value: 0 },
        { label: "审核中", value: 1 },
        { label: "审核未通过", value: 2 },
        { label: "审核通过", value: 3 }
      ],
      isMasterOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      agreementStatusOptions: [
        { label: "未上传", value: 0 },
        { label: "已上传", value: 1 }
      ],
      listQuery: {
        driverName: "",
        driverPhone: "",
        driverAuthStatus: "",
        licenseNumber: "",
        vehicleAuthStatus: "",
        isMaster: "",
        vehicleNature: "",
        agreementStatus: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  mounted() {
    this.VehicleTypeApi().then(() => {
      this.findList();
    });
  },
  methods: {
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        option => option.value == cellValue
      );
      return item ? item.label : "";
    },
    formatterIsMaster({ cellValue }) {
      const item = this.isMasterOptions.find(
        option => option.value == cellValue
      );
      return item ? item.label : "";
    },
    formatterVehicleNature({ cellValue }) {
      const item = this.vehicleTypeOptions.find(
        option => option.code == cellValue
      );
      return item ? item.name : "";
    },
    formatterAgreementStatus({ cellValue }) {
      const item = this.agreementStatusOptions.find(
        option => option.value == cellValue
      );
      return item ? item.label : "";
    },
    uploadVehicleAgreementApi() {
      uploadVehicleAgreement({
        code: this.rowObj.code,
        vehicleNature: this.vehicleNature,
        urls: [...this.imgList]
      }).then(() => {
        this.$message({ message: "操作成功", type: "success" });
        this.findList();
        this.collectionAgreementFlag = false;
      });
    },
    funcBatchConfirm() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({ message: "请选择需要确认的项", type: "warning" });
        return;
      }
      const codes = checkedRowArray.map(item => item.code);
      this.$confirm(`确认批量确认选中的 ${codes.length} 条数据吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          batchConfirm(codes).then(() => {
            this.$message({ message: "操作成功", type: "success" });
            this.findList();
          });
        })
        .catch(() => {});
    },
    VehicleTypeApi() {
      return VehicleType({ type: "vehicleNature" }).then(response => {
        this.vehicleTypeOptions = response.data.records;
      });
    },
    hideCollectionAgreementLogListModel() {
      this.collectionAgreementLogListFlag = false;
    },
    showCollectionAgreementLogListModel(code) {
      this.collectionAgreementLogListFlag = true;
      this.$refs.collectionAgreementLogListRef.init(code);
    },
    showCollectionAgreementModel(row) {
      this.rowObj = row;
      this.imgList = row.agreementUrls || [];
      this.vehicleNature = row.vehicleNature + "";
      this.collectionAgreementFlag = true;
    },
    findList() {
      this.loading = true;
      return pendingConfirmList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    }
  }
};
</script>

<style>
.vehicle-agreement-form {
  padding: 20px;
}

.vehicle-agreement-form .form-section {
  margin-bottom: 24px;
}

.vehicle-agreement-form .form-section h3 {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 12px;
}

.vehicle-agreement-form .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.vehicle-agreement-form .el-radio {
  font-size: 14px;
  color: #606266;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #ebf0f5;
  margin-top: 10px;
  text-align: right;
}
</style>
